export type CreditFormatOptions = {
  locale?: 'en-US' | 'en-IN'
  suffix?: 'cr' | 'credits' | 'none'
  sign?: 'always' | 'auto'
}

const toSafeInteger = (value: number | null | undefined): number => {
  if (typeof value !== 'number' || !Number.isFinite(value)) return 0
  return Math.trunc(value)
}

export const formatCreditNumber = (value: number | null | undefined, locale: 'en-US' | 'en-IN' = 'en-US'): string => {
  const n = toSafeInteger(value)
  const absolute = Math.abs(n)
  if (absolute < 1000) return String(n)
  return n.toLocaleString(locale)
}

export const formatCredits = (value: number | null | undefined, options: CreditFormatOptions = {}): string => {
  const { locale = 'en-US', suffix = 'cr', sign = 'auto' } = options
  const n = toSafeInteger(value)
  const numeric = formatCreditNumber(n, locale)
  const withSign = sign === 'always' && n > 0 ? `+${numeric}` : numeric
  if (suffix === 'none') return withSign
  return `${withSign} ${suffix}`
}

export const formatCreditDelta = (delta: number | null | undefined, options: CreditFormatOptions = {}): string =>
  formatCredits(delta, { ...options, sign: 'always' })
